/* eslint-env browser */
/* global window */

import Domodule from 'domodule';
import formobj from 'formobj';
import cookieMonster from '@firstandthird/cookie-monster';
import { removeClass, addClass, on, find, show, hide, closest } from 'domassist';

const COOKIE_NAME = 'onboarding';
const CLASSES = {
  SELECT: 'select',
  DONE: 'done',
  READY: 'ready',
  NO_TRANSITION: 'no-transition'
};

export default class Onboarding extends Domodule {
  postInit() {
    const userOnboarding = window.user ? window.user.onboarding : false;
    const onboardingCookie = userOnboarding || cookieMonster.get(COOKIE_NAME);
    const isValidCookie = onboardingCookie &&
        onboardingCookie.supporting &&
        onboardingCookie.category;
    const isModal = !this.els.done;

    this.currentStep = 1;
    this.form = formobj(this.els.form);
    this.supporting = this.find('[name="supporting"]');
    this.categories = this.find('[name="category"]');

    if (isValidCookie && !isModal) {
      this.animateIn(CLASSES.DONE);
      this.initializeData(onboardingCookie);
    } else {
      this.animateIn(CLASSES.SELECT);
      this.goToStep(1);
    }

    on(this.supporting, 'change', () => {
      addClass(this.el, `supporting-${this.form.getJSON().supporting}`);
      this.goToStep(2);
    });

    on(this.categories, 'change', () => {
      this.submit();
    });
  }

  animateIn(className) {
    addClass(this.el, className);
    setTimeout(() => {
      addClass(this.el, CLASSES.READY);
    }, 500);
  }

  initializeData(data) {
    this.supporting.forEach(input => {
      input.checked = data.supporting === input.value;
    });

    this.categories.forEach(input => {
      input.checked = data.category.indexOf(input.value) > -1;
    });
  }

  reset(el, event) {
    if (event && event.preventDefault()) {
      event.preventDefault();
    }

    if (this.el.classList.contains(CLASSES.DONE)) {
      removeClass(this.el, CLASSES.DONE);
      removeClass(this.el, CLASSES.READY);

      setTimeout(() => {
        this.animateIn(CLASSES.SELECT);
      }, 500);
    } else {
      addClass(this.el, CLASSES.NO_TRANSITION);
    }

    this.supporting.concat(this.categories).forEach(input => {
      input.checked = false;
    });

    this.goToStep(1);

    setTimeout(() => {
      removeClass(this.el, CLASSES.NO_TRANSITION);
      removeClass(this.el, 'supporting-0');
      removeClass(this.el, 'supporting-1');
    }, 250);
  }

  submit(el, event) {
    if (event) {
      event.preventDefault();
    }

    const form = this.form.getJSON();
    const data = { supporting: form.supporting, category: form.category };
    cookieMonster.set(COOKIE_NAME, data);
    const url = `${this.els.form.getAttribute('action')}?${this.form.getQueryString()}`;
    window.location = `${window.location.origin}${url}`;
  }

  goToStep(step) {
    removeClass(this.el, `step-${this.currentStep}`);
    addClass(this.el, `step-${step}`);

    this.currentStep = step;
    this.els.progress.setAttribute('aria-valuenow', step);
  }
}

class OnboardingModal extends Domodule {
  postInit() {
    const userOnboarding = window.user ? window.user.onboarding : false;
    const onboardingCookie = userOnboarding || cookieMonster.get(COOKIE_NAME);
    const isValidCookie = onboardingCookie &&
      onboardingCookie.supporting &&
      onboardingCookie.category;
    this.triggers = find('[data-onboarding-trigger]');
    this.isOpen = false;

    if (!isValidCookie) {
      this.triggers.forEach(trigger => {
        const flyout = closest(trigger, '.onboarding-flyout');

        if (flyout) {
          addClass(trigger.parentElement, 'ready');
        }
      });
    }

    on(this.triggers, 'click', this.open.bind(this));
    on(document, 'keydown', this.onKeydown.bind(this));

    setTimeout(() => {
      this.onboarding = Domodule.getInstance(
        this.findOne('[data-module="Onboarding"]')
      );
    });
  }

  onKeydown(event) {
    if (event.keyCode === 27) {
      this.close();
    }
  }

  open(event) {
    event.preventDefault();

    if (!this.isOpen) {
      this.isOpen = true;
      show(this.el);
      addClass(document.body, 'onboarding-open');
    }
  }

  close() {
    if (this.isOpen) {
      this.isOpen = false;
      hide(this.el);
      this.onboarding.reset();
      removeClass(document.body, 'onboarding-open');
    }
  }
}

Domodule.register('Onboarding', Onboarding);
Domodule.register('OnboardingModal', OnboardingModal);
